import React from "react"
import { Typography } from "@mui/material"


export default function nameColumn() {
	return {
		name: "name", label: "Name",
		options: {
			headerAlign: 'left',
			customBodyRowRenderLite: value => <Typography variant="subtitle1">{value}</Typography>,
		}
	}
}